import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, ModalHelper, AlertModal, helper}  from "../app.js"; 

export default class AccTypeSelecter extends PureComponent 
{
    prevType = '';
    modal = null;

    constructor (props)
    {
        super(props);

        this.state = {
            types: {},
            type: this.props.init_type ? this.props.init_type : '',
            loading: false 
        };
        this.prevType = this.state.type;

        this.modal = new ModalHelper(this);

        this.isActive = this.isActive.bind(this);
        this.selectType = this.selectType.bind(this);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
    }
    isActive ()
    {
        return !!this.props.tray_articul;
    }
    loadTypes ()
    {
        if (this.isActive())
        {
            const queryParams = {tray_articul: this.props.tray_articul};
            
            this.setState({loading: true});

            Server.instance
                .query('get_accessory_types', queryParams)
                .then((recievedAccTypes) =>
                {
                    const types = {};

                    recievedAccTypes.forEach(function (fields)
                    {
                        types[fields.id] = fields.name;
                    });
                    
                    this.setState({types, loading: false});
                })
                .catch(() => this.setState({types: {}, loading: false}));
        }
    } 
    selectType (e)
    {
        const type = e.target.value;

        this.setState({type});        

        if (type in this.state.types)
        {
            this.props.on_select(type, 'type');
            this.prevType = type;
        } 
        else
        {
            this.props.on_select(null, 'type');
            this.prevType = null;
        }     
    }
    componentDidMount() 
    {
        this.loadTypes();
    }
    componentDidUpdate () 
    {
        if (this.props.init_type !== this.prevType) 
        {
            this.setState({type: this.props.init_type});
            this.prevType = this.props.init_type;
        }
    }
    render () 
    {
        const typesList = Object.keys(this.state.types).map(type => 
            {
                return <option key={type} value={type}>{this.state.types[type]}</option>;
            });
        typesList.unshift(<option key="none" value="">Тип аксессуара не выбран</option>);

        return (<><Form.Row>
                    <Form.Group>
                        <Form.Label className={!this.isActive() ? 'text-muted' : ''}>Тип аксессуара:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                        <Form.Control onChange={this.selectType} onClick={this.modal.showProjectChangeWarning} value={this.state.type} disabled={!this.isActive()} custom as="select">{typesList}</Form.Control>
                    </Form.Group>
                </Form.Row>
                <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>);
    }
}